import { render, staticRenderFns } from "./payMyDeposit.vue?vue&type=template&id=05f2754f&scoped=true"
import script from "./payMyDeposit.vue?vue&type=script&lang=js"
export * from "./payMyDeposit.vue?vue&type=script&lang=js"
import style0 from "./payMyDeposit.vue?vue&type=style&index=0&id=05f2754f&prod&lang=scss"
import style1 from "./payMyDeposit.vue?vue&type=style&index=1&id=05f2754f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2754f",
  null
  
)

export default component.exports